import { useTranslation } from 'react-i18next';

import {
  ModernSplashMark,
  ModernSplashScreen,
} from '@modern/components/ui/splash/splash.styled';

export const ModernSplash = () => {
  const { t } = useTranslation();

  return (
    <ModernSplashScreen role="status" aria-label={t('common:loading')}>
      <ModernSplashMark />
    </ModernSplashScreen>
  );
};
